import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";

import type { DealerAdminFormPayload } from "modules/DealerDetails";

const FormHelper = createFormHelper<DealerAdminFormPayload>();

type DmsSystemProps = {
  tabId: string;
};

export const DmsSystem = ({ tabId }: DmsSystemProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="dealer-details-section">
      <div className="section-title">
        <div>
          <Icon className="cloud" />
        </div>
        <span className="section-title-text">{t("v8_dms_system", "DMS / System")}</span>
      </div>
      <div className="dealer-details-subheading">{t("v8_system_info", "System info")}</div>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_system_admin_name", "System admin name")}</label>
          <FormHelper.Field.Input name="sys_admin_name" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_system_admin_email", "System admin e-mail")}</label>
          <FormHelper.Field.Input name="sys_admin_email" />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_system_admin_phone", "System admin phone")}</label>
          <FormHelper.Field.Input name="sys_admin_phone" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_dms_server_information", "DMS Server information")}</label>
          <FormHelper.Field.Input name="dms_server_info" />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={16}>
          <label>{t("v8_general_system_network_information", "General system / Network information")}</label>
          <FormHelper.Field.TextArea name="network_info" />
        </Form.Field>
      </Form.Group>
    </Element>
  );
};
